import "./style.css";
import gsap from "gsap";

export default class Hero {
  static selector = ".s-hero";

  constructor(block) {
    this.block = block;
    this.animation =
      block.classList.contains("s-hero__has-animation") &&
      !document.documentElement.classList.contains(".hero-animated");
  }

  animate() {
    this.animation = false;
    const $image = this.block.querySelector(".s-hero__image");
    const $content = this.block.querySelector(".s-hero__content");
    const $title = this.block.querySelector("h1");
    const $scroll = this.block.querySelector(".s-hero__scroll");

    gsap.to([$image, $content], {
      delay: 1,
      ease: "power2.out",
      duration: 3.5,
      autoAlpha: 1,
    });

    gsap.to([$title], {
      delay: 2,
      ease: "power4.inOut",
      duration: 1.2,
      y: 0,
    });

    gsap.to([$scroll], {
      delay: 3,
      ease: "elastic.out",
      duration: 2.5,
      onComplete: () => {
        document.documentElement.classList.add("hero-animated");
      },
      y: 0,
    });
  }

  onReady() {
    this.parallax = parseFloat(this.block.getAttribute("data-parallax"), 10);
    this.$image = this.block.querySelector(".s-hero__image");
    if (this.animation) {
      this.animate();
    }
  }

  onScroll({ y }) {
    const { $image, parallax } = this;
    gsap.set($image, { y: y / parallax });

    const { height } = this.block.getBoundingClientRect();

    if (y > height) {
      document.body.classList.add("hero-scrolled");
    } else {
      document.body.classList.remove("hero-scrolled");
    }
  }
}
